import { useMediaQuery } from '@mui/material';
import { useAppSelector } from '.';

export const useGetCurrentMode = () => {
  const mode = useAppSelector((state) => state.user.mode);
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  return mode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : mode;
};
